import { HeroCarousel } from "../../components/HeroCarousel";
import { SafeImg } from "../../components/SafeImg";
import { Intro, Perks, SearchCard, useHero, useSlide } from "./parts";

export const ClassicHome = ({ data }) => {
  const hero = useHero(data);
  return (
  <>
    {data.slides.length > 0 && <HeroCarousel slides={data.slides} headline={hero.headline} intro={hero.intro} />}
    <div className="container-x relative z-30 -mt-28">
      <SearchCard className="shadow-[0_40px_80px_-40px_rgba(18,25,23,0.45)] backdrop-blur-md" />
    </div>
    <Perks />
  </>
  );
};

export const MinimalHome = ({ data }) => {
  const [first, ...rest] = data.slides;
  const hero = useHero(data);
  return (
    <>
      <section className="container-x pt-14 sm:pt-20" data-testid="minimal-hero">
        <p className="eyebrow">{data.brand.tagline}</p>
        <h1 className="mt-3 max-w-4xl font-serif text-4xl font-semibold leading-[1.05] text-ink sm:text-5xl lg:text-6xl" data-testid="hero-caption">{hero.headline || first?.caption || data.brand.name}</h1>
        {hero.intro ? <Intro text={hero.intro} className="text-ink/65" /> : <p className="mt-4 max-w-xl text-ink/60">{first?.subtitle}</p>}
        <SearchCard title="Check availability" className="mt-10 !rounded-2xl !border-ink/10" />
      </section>
      {first && (
        <section className="container-x mt-10 grid gap-4 md:grid-cols-3" data-testid="minimal-gallery">
          <SafeImg src={first.image} alt={first.caption} className="h-72 w-full rounded-2xl object-cover md:col-span-2 md:h-[420px]" />
          <div className={`grid gap-4 ${rest.length === 1 ? "" : "md:grid-rows-2"}`}>
            {(rest.length ? rest : [first]).slice(0, 2).map((s, k) => <SafeImg key={k} src={s.image} alt={s.caption} className={`w-full rounded-2xl object-cover ${rest.length === 1 ? "h-40 md:h-[420px]" : "h-40 md:h-[202px]"}`} />)}
          </div>
        </section>
      )}
      <Perks variant="numbers" />
    </>
  );
};

export const ResortHome = ({ data }) => {
  const [s, i] = useSlide(data.slides);
  const hero = useHero(data);
  return (
    <>
      <section className="relative grid min-h-[620px] place-items-center overflow-hidden bg-shade sm:min-h-[78vh]" data-testid="resort-hero">
        {data.slides.map((sl, k) => (
          <img key={k} src={sl.image} alt={sl.caption} className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-[1400ms] ${k === i ? "opacity-100" : "opacity-0"}`} />
        ))}
        <div className="absolute inset-0 bg-shade/45" />
        <div className="container-x relative pb-40 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-paper/85">{s.subtitle}</p>
          <h1 key={i} className="mx-auto mt-5 max-w-4xl animate-rise font-serif text-4xl uppercase leading-[1.02] text-paper sm:text-6xl lg:text-7xl" data-testid="hero-caption">{hero.headline || s.caption || data.brand.name}</h1>
          <Intro text={hero.intro} className="mx-auto text-lg text-paper/90" />
        </div>
      </section>
      <div className="container-x relative z-30 -mt-36">
        <SearchCard title="Plan your escape" className="shadow-2xl" />
      </div>
      <Perks variant="tiles" />
    </>
  );
};
